// extracted by mini-css-extract-plugin
export default {"shopAdminLayout":"shopAdminLayout_shopAdminLayout__WD2cF","center":"shopAdminLayout_center__9bbXq"};